export const PREVIEW_CLASSNAME = 'HS_GLOBAL_STYLES_PREVIEW';
export const CSS_VAR_STYLE_EL_ID = 'HS_CSS_VARS';
export const FONT_STYLE_EL_ID = 'HS_FONT_STYLES';
export const FONTS_BASE_KEY = ['groupFoundation', 'groupFonts', 'groupFontElements'];